export const TITLE_TRACKING_ATTRIBUTE = 'data-tracking-label';
